module.exports = __webpack_public_path__ + "static/media/ailin-prof.597fb743.svg";